import styled from "styled-components";
import { Link } from "react-router-dom";
import { colors, fonts } from "../../../styles/variables";
import breakpoints from "../../../styles/breakpoints";

import selectIcon from "../../../assets/images/icons/arrow-down.svg";
import textareaIcon from "../../../assets/images/icons/arrow-down-right.svg";
import cardIcon from "../../../assets/images/icons/card.svg";

export const inputStyles = `
height: 60px;
padding: 10px 15px;
width: 100%;
-webkit-appearance: none;
-moz-appearance: none;
border: 1px solid ${colors.black};
background-color: transparent;
font-family: ${fonts.fontConceptRegular};
border-radius: 0;

::-webkit-input-placeholder {
  color: ${colors.black};
  font-family: ${fonts.fontConceptRegular};
  opacity: .7;
}
::-moz-placeholder {
  color: ${colors.black};
  font-family: ${fonts.fontConceptRegular};
  opacity: .7;
}
:-ms-input-placeholder {
  color: ${colors.black};
  font-family: ${fonts.fontConceptRegular};
  opacity: .7;
}
:-moz-placeholder {
  color: ${colors.black};
  font-family: ${fonts.fontConceptRegular};
  opacity: .7;
}
&:focus {
  outline: none;
}
`;

export const Input = styled.input`
  ${inputStyles}

  :read-only {
    background: ${colors.lightgray};
    cursor: not-allowed;
  }

  :-moz-read-only {
    background: ${colors.lightgray};
    cursor: not-allowed;
  }
`;

export const InputSelect = styled.select`
  ${inputStyles};
  padding-right: 40px;
  background: url(${selectIcon}) no-repeat right 15px center;
  border-radius: 0;

  :disabled {
    background: ${colors.lightgray};
    cursor: not-allowed;
  }
`;

export const Textarea = styled.textarea<{ isResizableText?: boolean; customHeight?: string }>`
  ${inputStyles};
  min-height: 60px;
  resize: ${(props) => (props.isResizableText ? "vertical" : "none")};
  padding-bottom: 25px;
  background: url(${textareaIcon}) no-repeat right 10px bottom 10px;
  margin-top: 40px;
  height: ${(props) => (props.isResizableText ? props.customHeight : "60px")};
`;

export const InputCard = styled.input`
  ${inputStyles};
  padding-left: 50px;
  padding-right: 90px;
  background: url(${cardIcon}) no-repeat left 15px center;
  position: relative;
`;

export const InputCardType = styled.span`
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  text-transform: uppercase;
  font-size: 14px;
  font-family: ${fonts.fontConceptRegular};
`;

export const StyledInputHolder = styled.div`
  margin-bottom: 10px;
  position: relative;
`;

export const StyledInputHolderMd = styled(StyledInputHolder)`
  margin-bottom: 20px;
`;

export const StyledInputHolderLarge = styled(StyledInputHolder)`
  margin-bottom: 35px;
  margin-top: -25px;
`;

export const StyledFormText = styled.span`
  font-size: 11px;
  font-family: ${fonts.fontBauRegular};
  text-align: left;
  display: inline-block;
  line-height: 1.35;
  ${breakpoints.smDown} {
    margin-bottom: 10px;
  }
`;

export const StyledFormTextBoldLink = styled(Link)`
  font-size: 10px;
  font-family: ${fonts.fontInterstateUltraBlack};
  text-transform: uppercase;
  line-height: 1.35;
  display: block;
`;
